// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=qa` then `environment.qa.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import { bucketPolicySecrets } from './secrets/secrets.qa';

export const environment = {
  production: false,
  portal: {
    url: 'https://portal-qa.in2l.com',
  },
  portalApi: {
    url: 'https://api-qa.in2lolympus.com',
  },
  portalCompositeApi: {
    url: 'https://api-qa.in2lconnect.com/in2l-portal-cmp/v1',
  },
  deviceApi: {
    url: 'https://api-qa.in2lconnect.com/device/v1',
  },
  authApi: {
    url: 'https://api-qa.in2lconnect.com/auth/v1',
    tokenExpirationMin: 14,
  },
  databaseApi: {
    url: 'https://api-qa.in2lconnect.com/database/v1',
  },
  mediaApi: {
    url: 'https://api-qa.in2lconnect.com/media/v1',
  },
  userApi: {
    url: 'https://api-qa.in2lconnect.com/user/v1',
  },
  contentApi: {
    url: 'https://api-qa.in2lconnect.com/content/v1',
  },
  google: {
    analytics: {
      ua: 'UA-97566542-1', // qa ua id
    },
  },
  bucketPolicy: {
    fields: {
      acl: 'public-read',
      'Content-Type': '',
      key: '',
      bucket: 'in2l-qa',
      'x-amz-algorithm': 'AWS4-HMAC-SHA256',
      ...bucketPolicySecrets,
    },
    host: 'https://in2l-qa.s3.dualstack.us-east-1.amazonaws.com',
    starts_with: [{ 'Content-Type': '' }, { key: '' }],
  },
};
